<template>
  <div class="sm-error-handler">
    <transition name="fade">
      <div
        v-if="currentError && !popup.isOpen"
        class="sm-error-handler__message"
      >
        <a 
          href="#"
          class="sm-error-handler__message-close"
          @click.prevent="closeCurrentError"
        ></a>
        <include-svg :name="'icon-expl'" />
        <h5>Something went wrong</h5>
        <p>{{currentError.errors[0]}}{{currentError.errors.length > 1 ? ' ...' : ''}}</p>
        <a
          href="#"
          class="sm-error-handler__message-details sm-h5"
          @click.prevent="showDetails"
        >Show details</a>
      </div>
    </transition>

    <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      @close="popup.isOpen = false"
    >
      <template slot="popupContent">
        <div
          v-if="popup.type == 'details'" 
          class="sm-error-handler__popup"
        >
          <h4>Something went wrong</h4>
          <ul>
            <li
              v-for="error in currentError.errors"
              :key="error"
            >{{error}}</li>
          </ul>
          <div class="sm-error-handler__popup-controls">
            <btn-block
              :type="'small'"
              :class="'sm-btn--grey-2'"
              :text="'Send to Support'"
              @click="openSendForm"
            />
            <btn-block
              :type="'small'"
              :text="'Ignore'"
              @click="popup.isOpen = false"
            />
          </div>
        </div>
        <div
          v-if="popup.type == 'send'" 
          class="sm-error-handler__popup"
        >
          <h4>Send this issue to Support</h4>
          <label class="sm-small">Describe the issue you encountered (optional)</label>
          <textarea
            v-model="userDescription"
            class="sm-textarea"
          />
          <div class="sm-error-handler__popup-controls">
            <btn-block
              :type="'small'"
              :class="'sm-btn--grey'"
              :text="'Cancel'"
              @click="closeSendForm"
            />
            <btn-block
              :type="'small'"
              :text="'Send'"
              @click="sendForm"
            />
          </div>
        </div>
        <div
          v-if="popup.type == 'send-success'" 
          class="sm-error-handler__popup"
        >
          <h4>Success!</h4>
          <p>This issue has been reported. Thank you!</p>
          <btn-block
            :type="'small'"
            :text="'Ok'"
            @click="popup.isOpen = false"
          />
        </div>
      </template>
    </popup-block>

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Popup from '@/components/Popup';
import Spinner from '@/components/Spinner';

export default {
  name: 'error-handler',
  components: {
    'popup-block': Popup,
    'sm-spinner': Spinner
  },
  data() {
    return {
      popup: {
        isOpen: false,
        type: 'details' // values: details, send, send-success
      },
      userDescription: '',
      showSpinner: false
    }
  },
  computed: {
    ...mapGetters({
      apiErrors: 'apiErrors'
    }),
    currentError() {
      return this.apiErrors.length ? this.apiErrors[0] : null
    }
  },
  created() {

  },
  methods: {
    ...mapActions({
      removeApiError: 'removeApiError',
      createTicket: 'createTicket',
    }),
    closeCurrentError() {
      this.removeApiError(this.currentError.id);
    },
    showDetails() {
      this.popup.type = 'details';
      this.popup.isOpen = true;
    },
    openSendForm() {
      this.popup.type = 'send';
    },
    closeSendForm() {
      this.popup.type = 'details';
    },
    sendForm() {
      let sendData = Object.assign({}, this.currentError);

      sendData.user_description = this.userDescription;
      delete sendData.id;
      delete sendData.errors;

      this.showSpinner = true;
      this.createTicket(sendData)
        .then(res => {
          this.showSpinner = false;
          this.popup.type = 'send-success';
        });
    }
  },
  watch: {
    'popup.isOpen'(val) {
      if (!val) {
        this.closeCurrentError();
        this.userDescription = '';
      }
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/components/_error-handler.scss';

  .fade-enter,
  .fade-leave-to {
    transform: translate(0, 100%);
  }

  .fade-enter-active {
    transition: transform .5s;
  }

  .fade-leave-active {
    transition: transform .2s;
  }
</style>